<template>
  <div class="d-inline-flex flex-column align-center">
    <v-tooltip bottom>
      <template #activator="{ on }">
        <div class="d-flex">
          <v-img
            :src="flag"
            :alt="text"
            :max-width="size"
            :min-width="size"
            :height="size"
            class="flag grey"
            v-on="showTooltip ? on : null"
          >
            <template #placeholder>
              <div class="text-center text-caption">
                <v-icon dark small>language</v-icon>
              </div>
            </template>
          </v-img>
          <v-badge v-if="status" :color="badgeColour" dot bottom offset-x="5" offset-y="5" />
        </div>
      </template>
      <span>{{ text }}</span>
      <span v-if="status" class="ml-2 text-caption">({{ statusText }})</span>
    </v-tooltip>
    <div v-if="showLabel" class="text-center text-caption text-">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'FlagPip',
  props: {
    flag: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [String, Number],
      default: 20,
    },
    status: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    badgeColour() {
      switch (this.status) {
        case 'publish':
          return 'green'
        case 'pending':
          return 'green lighten-4'
        case 'draft':
          return 'warning'
        default:
          return null
      }
    },
    statusText() {
      switch (this.status) {
        case 'publish':
          return 'Published'
        case 'pending':
          return 'Pending Review'
        case 'draft':
          return 'Draft'
        default:
          return 'No Article'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.flag {
  border-radius: 999px;
  box-shadow: 0 0 0 1px #ddd;
}
</style>
